import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AgGridAngular } from 'ag-grid-angular';
import * as moment from 'moment';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-user-new-payment',
  templateUrl: './user-new-payment.component.html',
  styleUrls: ['./user-new-payment.component.css']
})
export class UserNewPaymentComponent implements OnInit {
  @ViewChild('agGrid',{static:false}) agGrid: AgGridAngular;
  PaymentscolumnDefs = [
    {headerName: 'ID', field: '_id', width: 250, checkboxSelection: true,headerCheckboxSelection: true,sortable: true, filter: true},
    {headerName: 'Account ID', field: 'account_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Payment Date', field: 'payment_date', resizable: true, sortable: true, filter: true},
    {headerName: 'Payment Amount', field: 'payment_amount', resizable: true, sortable: true, filter: true},
    {headerName: 'Due amount', field: 'due_amount', resizable: true, sortable: true, filter: true},
    {headerName: 'Paid Date', field: 'paid_date', resizable: true, sortable: true, filter: true},
    {headerName: 'Last Payment Date', field: 'last_paid_amount', resizable: true, sortable: true, filter: true},
    {headerName: 'Next Payment Date', field: 'next_payment_date', resizable: true, sortable: true, filter: true},
    {headerName: 'Attachment URL', field: 'attachment_url', resizable: true, sortable: true, filter: true},
    {headerName: 'Created By', field: 'createdby', resizable: true, sortable: true, filter: true},
    {headerName: 'Creator Name', field: 'creator_name', resizable: true, sortable: true, filter: true},
    {headerName: 'Customer ID', field: 'customer_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Client ID', field: 'client_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Bank ID', field: 'bank_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Product ID', field: 'product_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Portfolio ID', field: 'portfolio_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Bucket ID', field: 'bucket_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Fintresle ID', field: 'finterstal_id', resizable: true, sortable: true, filter: true},
    {headerName: 'Passport Numbet', field: 'passport_no', resizable: true, sortable: true, filter: true},
    {headerName: 'Created At', field: 'createdAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
      return moment(data.value).format('LLLL');
    }},
    {headerName: 'Update At', field: 'updatedAt', resizable: true, sortable: true, filter: true, cellRenderer: (data) => {
      return moment(data.value).format('LLLL');
    }},
  ];
  
  PaymentsForm: UntypedFormGroup;
  areaCodeList: any;
  bankCodeList: any;
  fieldvisitCodeList: any;
  mStatusList: any;
  sStatusList: any;
  PaymentsList = [];
  login_Details: any;
  TracingToolsList: any;
  actionstakenList: any;
  uploaded: boolean;
  settlementData: any;
  LinkedAccounts: any[];
  selectedAcc: string;
  MarkCompleted_Status: boolean;
  CustomerData : any;
  check_allocation_status : any;

  loader_view = false;
  constructor(private formBuilder:UntypedFormBuilder, 
              private _api:ApiService, 
              @Inject(SESSION_STORAGE) private storage: StorageService, private dialog:MatDialog) { 
    this.PaymentsForm = this.formBuilder.group({
      _id:['',Validators.required],
      account_id:['',Validators.required],
      settlement_id:[''],
      payment_date:['',Validators.required],
      payment_amount:['',Validators.required],
      due_amount:[''],
      paid_date:['',Validators.required],
      total_installments:[''],
      current_installment:[''],
      attachment_url:[''],
      last_paid_amount:['',Validators.required],
      next_payment_date:[''],
      createdby:['',Validators.required],
      creator_name:['',Validators.required],
      customer_id:['',Validators.required],
      client_id :['',Validators.required],
      bank_id :['',Validators.required],
      product_id :['',Validators.required],
      portfolio_id :['',Validators.required],
      bucket_id :['',Validators.required],
      finterstal_id :['',Validators.required],
      passport_no :['',Validators.required]
    })
  }

  ngOnInit(): void {
    this.settlementData = this._api.getSETPAY();
    if (this.settlementData != null) {
      console.log(this.settlementData);
      this.PaymentsForm.patchValue({
        settlement_id:this.settlementData._id
      });
    } else {
      
    }

    if (localStorage.getItem('MarkCompleted') == 'true') {
      this.MarkCompleted_Status = true;
    } else {
      this.MarkCompleted_Status = false;
    }
    const LinkedData = {
      bucket_id: localStorage.getItem("Bucket_ID"),
      passport_no : localStorage.getItem("Passport_Number")

    }
    this._api.getLinkedaccounts(LinkedData).subscribe(data=>{
      if (data['Code']==200) {
        this.LinkedAccounts = data['Data'];
      } else {
        this.LinkedAccounts = [];
      }
    });

    this.selectedAcc = localStorage.getItem("Account_ID");
    this.login_Details = this.getFromLocal("login_Details");
    console.log(this.login_Details);

    this.PaymentsForm.patchValue({
      createdby: this.login_Details._id,
      creator_name: this.login_Details.name,
      customer_id: localStorage.getItem("Fintrestle_ID"),
      account_id:localStorage.getItem("Account_ID"),
      client_id : localStorage.getItem("Client_ID"),
      bank_id : localStorage.getItem("Bank_ID"),
      product_id : localStorage.getItem("Product_ID"),
      portfolio_id : localStorage.getItem("Portfolio_ID"),
      bucket_id : localStorage.getItem("Bucket_ID"),
      finterstal_id : localStorage.getItem("Fintrestle_ID"),
      passport_no : localStorage.getItem("Passport_Number"),
    })
    this._api.getlist_new_payment(localStorage.getItem("Fintrestle_ID")).subscribe(data=>{
      if (data['Code']==200) {
        this.PaymentsList = data['Data'];
      } else {
        this.PaymentsList = null;
      }
    });


    if (this.storage.get("_storedRecord")) {
     let loadedRecord = this.storage.get("_storedRecord")
      let dataList = loadedRecord.dataList;
      if (loadedRecord.keyvalue.customer_details[0].insert_id != undefined) {
        const tempdata = loadedRecord.keyvalue.customer_details;
        this.CustomerData = tempdata[0];
        console.log("Cusotmer_details *******************",this.CustomerData);
      } else {
        const tempdata = loadedRecord.keyvalue.customer_details;
        let CustomernewData = JSON.parse(tempdata[0]);
        this.CustomerData = CustomernewData[0];
        console.log("Cusotmer_details *******************",this.CustomerData);
      }
    }


    let logindetail = this.getFromLocal("login_Details");
    console.log(logindetail);
    let values = {
      "finterstal_id":localStorage.getItem("Fintrestle_ID"),
      "assigned_to":logindetail._id
    }
    console.log(values);
    this._api.check_allocation_status(values).subscribe(data=>{
      if (data['Code']==200) {
        let check_allocation = data['Data'];
        console.log(check_allocation);
        if(check_allocation == null){
         this.check_allocation_status = false;
        }else{
          this.check_allocation_status = true;
        }
        console.log(this.check_allocation_status);
      } else {
      }
    });



  }

  getFromLocal(key): any {
    return this.storage.get(key);
  }

  getFile(event){
    this.uploaded = false;
    const File = event.target.files[0];
    console.log(File);
    this._api.uploadFile(File).subscribe(data=>{
      if (data['Code'] = 200) {
        this.PaymentsForm.patchValue({
          attachment_url:data['Data']
        })
        this.uploaded = true;
      } else {
        this.PaymentsForm.patchValue({
          attachment_url:data['Data']
        })
        this.uploaded = false;
      }
    })
  }

  addNewPayments(){
   
    if(this.check_allocation_status == false){
      alert("You don't have the access");   
      } else
      {

    this.loader_view = true;

    this.PaymentsForm.patchValue({
      _id:new Date().getTime(),
      log_date:new Date()
    });
    console.log(this.PaymentsForm.value.payment_amount);
    if (this.settlementData != null) {
      if (this.PaymentsForm.valid) {
       
        if(this.PaymentsForm.value.payment_amount > this.CustomerData.total_out_standing && this.login_Details.designation !== 'Super Admin'){
                alert('Enter the Value Below Outstanding amount');
                this.loader_view = false;
        }else{
          // this._api.create_new_payment(this.PaymentsForm.value).subscribe(data=>{
          //   if (data['Code'] == 200) {
          //     this.onPagereload();
          //     this._api.setSETPAY(null);
          //     alert(data['Message']);
          //   } else {
          //     alert(data['Message']);
          //   }
          //   this.loader_view = false;
          // });
          // alert('Inserting');
        }
      } else {
        console.log(this.PaymentsForm.value);
        alert('Form No Valid');
        this.loader_view = false;
      }
    } else {
      if (this.PaymentsForm.valid) {
        if(this.PaymentsForm.value.payment_amount > this.CustomerData.total_out_standing && this.login_Details.designation !== 'Super Admin'){
          alert('Enter the Value Below Outstanding amount');
          this.loader_view = false;
  }else{
    this._api.create_new_payment(this.PaymentsForm.value).subscribe(data=>{
      if (data['Code'] == 200) {
        this.onPagereload();
        this._api.setSETPAY(null);
        alert(data['Message']);
      } else {
        alert(data['Message']);
      }
      this.loader_view = false;
    });
    // alert('Inserting');
  }


      } else {
        console.log(this.PaymentsForm.value);
        alert('Form No Valid');
        this.loader_view = false;
      }
    }

  }

   
  }

  onPagereload(){

      this.loader_view = false;
      this._api.getlist_new_payment(localStorage.getItem("Fintrestle_ID")).subscribe(data=>{
        if (data['Code']==200) {
          this.PaymentsList = data['Data'];
        } else {
          this.PaymentsList = null;
        }
      });
  }

  close(){
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to close it!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.dialog.closeAll();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
      }
    })
    
  }
}
